import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Box, TablePagination, Card, Tabs, Tab, Grid, Typography, MenuItem, Select, TextField,
    FormControl, InputLabel, Button, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Table, Container, InputAdornment
} from "@mui/material";
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { makeApiRequest } from '../../../utils/api';
import { trimSeconds, formatTimeToHoursMinutes, formatDate } from '../../../helpers/timeHelper';
import { getLocationList, getLocation } from '../../../helpers/commonHelper';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { jsPDF } from "jspdf";
import { Search } from "@mui/icons-material";
import "jspdf-autotable";
import * as XLSX from 'xlsx';
import GridOnIcon from '@mui/icons-material/GridOn';
const env = process.env.REACT_APP_ENV || 'development';

const ViewStudentTask = () => {
    const todayDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const [month, day, year] = todayDate.split('/');
    const formattedDate = `${year}-${month}-${day}`;
    const today_date = formattedDate;
    const control = localStorage.getItem('control');
    const userLocation = getLocation(localStorage.getItem('userLocation'));
    const userName = (control != 1 && control != 4) ? localStorage.getItem('userid') : null;
    const userId = localStorage.getItem('userid');

    const [value, setValue] = useState('today');
    const [location, setLocation] = useState("All Locations");
    const [studentName, setStudentName] = React.useState('');
    const [startDate, setStartDate] = useState(today_date);
    const [endDate, setEndDate] = useState(today_date);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [learningData, setLearningData] = useState([]);
    const [locations, setLocations] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [selectedBatch, setSelectedBatch] = useState("");
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: 'asc'
    });
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const getStudentNameList = async (location, batchId) => {
        try {
            setLoading(true);
            const response = await makeApiRequest('post', '/api/student/list_view', {
                location: location,
                batch_id: batchId || '',
                token: localStorage.getItem('authToken'),
            });

            if (response.status === 'success') {
                setStudentList(response.data);
            } else {
                throw new Error('Failed to fetch student list');
            }
        } catch (err) {
            console.error('Error fetching student list:', err);
            setError(err.response?.data?.message || 'Error fetching student list');
            toast.error(err.response?.data?.message || 'Error fetching student list');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        listLocation();

        if (value === 'today') {
            if (control == 3) {
                setLocation(userLocation);
                setStudentName(userName);
                fetchStudentDataToday();
            } else if (control == 2 || control == 4) {
                setLocation(userLocation);
                getStudentNameList(userLocation);
                fetchStudentDataToday();
            } else {
                fetchStudentDataToday();
            }
        }
    }, [value, location, studentName, control]);

    const listLocation = () => {
        const locationList = getLocationList();
        setLocations(locationList);
    };

    const fetchStudentData = async (pageValue = page, rowsPerPageValue = rowsPerPage) => {
        try {
            setHasSubmitted(true);
            setLoading(true);
            setError(null);
            setPage(0);

            const validRowsPerPage = Math.max(1, rowsPerPageValue); // Ensure per_page is positive

            const payload = {
                token: localStorage.getItem('authToken'),
                start_date: startDate,
                end_date: endDate,
                location: (control == 2 || control == 3 || control == 4) && userLocation ? userLocation : location,
                name: control == 3 ? userName : studentName,
                batch_id: selectedBatch,
                user_id: userId,
                page: pageValue + 1,
                per_page: validRowsPerPage,
            };

            const response = await makeApiRequest('post', '/api/learning/student', payload);

            if (response.status === 'success') {
                const data = response.data.data || [];
                setLearningData(data);
                const pagination = response.data.pagination || {};
                setTotalPages(pagination.last_page || Math.ceil(data.length / validRowsPerPage));
                setTotalRecords(pagination.total || data.length);
            } else {
                setLearningData([]);
                throw new Error('Invalid data received');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setLearningData([]);
            setError(err.response?.data?.message || 'Error fetching data');
            toast.error(err.response?.data?.errors?.per_page?.[0] || err.response?.data?.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    const fetchStudentDataToday = async (pageValue = page, rowsPerPageValue = rowsPerPage) => {
        try {
            setLoading(true);
            setError(null);
            setHasSubmitted(true);
            setPage(0);

            const validRowsPerPage = Math.max(1, rowsPerPageValue); // Ensure per_page is positive

            const payload = {
                token: localStorage.getItem('authToken'),
                start_date: formattedDate,
                end_date: formattedDate,
                location: (control == 2 || control == 3 || control == 4) && userLocation ? userLocation : location,
                name: control == 3 ? userName : studentName,
                batch_id: selectedBatch,
                page: pageValue + 1,
                per_page: validRowsPerPage,
            };

            const response = await makeApiRequest('post', '/api/learning/student', payload);

            if (response.status === 'success') {
                const data = response.data.data || [];
                setLearningData(data);
                const pagination = response.data.pagination || {};
                setTotalPages(pagination.last_page || Math.ceil(data.length / validRowsPerPage));
                setTotalRecords(pagination.total || data.length);
            } else {
                setLearningData([]);
                throw new Error('Invalid data received');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setLearningData([]);
            setError(err.response?.data?.message || 'Error fetching data');
            toast.error(err.response?.data?.errors?.per_page?.[0] || err.response?.data?.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchBatchData = async () => {
            try {
                const response = await makeApiRequest('post', '/api/listBatches/filter', {
                    token: localStorage.getItem('authToken'),
                });
                if (response?.status === 'success' && response.data) {
                    setBatchList(response.data);
                } else {
                    setBatchList([]);
                }
            } catch (err) {
                console.error("Error fetching batches:", err);
                setBatchList([]);
                toast.error(err.response?.data?.message || 'Error fetching batches');
            }
        };
        fetchBatchData();
    }, []);

    const handleChange = async (event, newValue) => {
        setStartDate("");
        setEndDate("");
        setHasSubmitted(false);
        if (control == 2 || control == 4) {
            setLocation(userLocation);
            getStudentNameList(userLocation);
            setStudentName("");
        } else if (control == 3) {
            setLocation(userLocation);
            setStudentName(userName);
        }

        if (newValue === 'today') {
            setStartDate(today_date);
            setEndDate(today_date);
            setLocation(userLocation);
            setStudentName(userName);
            fetchStudentDataToday();
        } else if (control == 1) {
            setStartDate("");
            setEndDate("");
            setLocation("");
            setStudentName("");
        }

        setValue(newValue);
        setLocation("");
        setStudentName("");
        setLearningData([]);
    };

    const handleSubmit = async () => {
        try {
            if (value === 'historical' && (!startDate || !endDate)) {
                toast.warn("Please choose start date and end date");
                return;
            }
            setLoading(true);
            setError(null);
            setHasSubmitted(true);
            setPage(0);

            const payload = {
                token: localStorage.getItem('authToken'),
                start_date: startDate,
                end_date: endDate,
                name: control == 3 ? userName : studentName,
                location: (control == 2 || control == 3 || control == 4) && userLocation ? userLocation : location,
                batch_id: selectedBatch,
                user_id: userId,
                page: 1,
                per_page: Math.max(1, rowsPerPage), // Ensure per_page is positive
            };

            const response = await makeApiRequest('post', '/api/learning/student', payload);

            if (response.status === 'success') {
                const data = response.data.data || [];
                setLearningData(data);
                const pagination = response.data.pagination || {};
                setTotalPages(pagination.last_page || Math.ceil(data.length / rowsPerPage));
                setTotalRecords(pagination.total || data.length);
            } else {
                setLearningData([]);
                throw new Error('Invalid data received');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err.response?.data?.message || 'Error fetching data');
            toast.error(err.response?.data?.errors?.per_page?.[0] || err.response?.data?.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    const handleLocationChange = async (event) => {
        setLocation(event.target.value);
        getStudentNameList(event.target.value);
    };

    const handleBatchChange = async (event) => {
        const newBatch = event.target.value;
        setSelectedBatch(newBatch);
        getStudentNameList(location, newBatch);
    };

    const handleStudentChange = (event) => {
        setStudentName(event.target.value);
    };

    const getFilteredData = (data) => {
        if (!searchText || !Array.isArray(data)) return data;

        return data.filter(item => {
            const searchLower = searchText.toLowerCase();
            return (
                (String(item.name || '').toLowerCase().includes(searchLower)) ||
                (String(item.user_id || '').toLowerCase().includes(searchLower)) ||
                (String(item.location || '').toLowerCase().includes(searchLower)) ||
                (String(item.task || '').toLowerCase().includes(searchLower)) ||
                (String(item.desc || '').toLowerCase().includes(searchLower)) ||
                (String(item.course || '').toLowerCase().includes(searchLower)) ||
                (formatDate(item.date || '').toLowerCase().includes(searchLower)) ||
                (trimSeconds(item.in_time || '').toLowerCase().includes(searchLower)) ||
                (trimSeconds(item.out_time || '').toLowerCase().includes(searchLower)) ||
                (formatTimeToHoursMinutes(item.duration || '').toLowerCase().includes(searchLower))
            );
        });
    };

    const fetchAllStudentData = async () => {
        try {
            setLoading(true);
            setError(null);
            const payload = {
                token: localStorage.getItem('authToken'),
                start_date: startDate,
                end_date: endDate,
                location: (control == 2 || control == 3 || control == 4) && userLocation ? userLocation : location,
                name: control == 3 ? userName : studentName,
                batch_id: selectedBatch,
                per_page: -1, // Fetch all records
            };

            const response = await makeApiRequest('post', '/api/learning/student', payload);

            if (response.status === 'success') {
                return response.data.data || [];
            } else {
                throw new Error('Invalid data received');
            }
        } catch (err) {
            console.error('Error fetching all data:', err);
            toast.error(err.response?.data?.message || 'Error fetching data for export');
            return [];
        } finally {
            setLoading(false);
        }
    };
    const handleExport = async () => {
        const data = await fetchAllStudentData();
        if (!data || data.length === 0) {
            toast.warn("No data available to export.");
            return;
        }
    
        const doc = new jsPDF();
        const title = value === "today" ? "Student Task Report (Today)" : "Student Task Report (Historical)";
        
        // Set title
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text(title, 14, 15);
    
        // Set generated date
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);
    
        // Define headers and data
        const headers = [["Student Name", "Date", "Duration", "Module", "Chapter", "Description"]];
        const body = data.map(item => [
            `${item.name || '-'} (${item.location || 'Unknown'} | ${item.user_id || '-'})`,
            formatDate(item.date) || '-',
            `${formatTimeToHoursMinutes(item.duration) || '-'} (${trimSeconds(item.in_time) || '-'} to ${trimSeconds(item.out_time) || '-'})`,
            item.module || '-',
            item.chapter || '-',
            item.desc || '-'
        ]);
    
        // Configure autoTable
        doc.autoTable({
            startY: 30,
            head: headers,
            body: body,
            theme: 'grid',
            styles: {
                font: 'helvetica',
                fontSize: 8, // Reduced font size for compactness
                cellPadding: 2, // Reduced padding for cleaner look
                textColor: [0, 0, 0],
                lineColor: [100, 100, 100], // Darker, thinner lines
                lineWidth: 0.2, // Thinner borders
                overflow: 'linebreak', // Handle long text
            },
            headStyles: {
                fillColor: [70, 130, 180],
                textColor: [255, 255, 255],
                fontStyle: 'bold',
                halign: 'center',
                fontSize: 9, // Slightly larger header font
            },
            alternateRowStyles: {
                fillColor: [245, 245, 245], // Light grey for alternate rows
            },
            columnStyles: {
                0: { cellWidth: 45 }, // Student Name (slightly reduced)
                1: { cellWidth: 25 }, // Date (adjusted for balance)
                2: { cellWidth: 35 }, // Duration (adjusted for time range)
                3: { cellWidth: 25 }, // Module
                4: { cellWidth: 25 }, // Chapter
                5: { cellWidth: 35 }, // Description (adjusted for text)
            },
            margin: { top: 30, left: 10, right: 10 }, // Adjusted margins for better fit
            didDrawPage: (data) => {
                // Add page numbers
                const pageCount = doc.internal.getNumberOfPages();
                const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
                doc.setFontSize(8);
                doc.setTextColor(100);
                doc.text(`Page ${pageNumber} of ${pageCount}`, 190, 287, { align: 'right' });
            },
        });
    
        // Add footer text
        doc.setFontSize(7);
        doc.setTextColor(100);
        doc.text("Generated by Student Management System", 10, 287);
    
        doc.save(`${value === "today" ? "today" : "historical"}-student-task-report.pdf`);
    };

    const handleExportExcel = async () => {
        const data = await fetchAllStudentData();
        if (!data || data.length === 0) {
            toast.warn("No data available to export.");
            return;
        }

        const headers = ["Student Name", "Date", "Duration", "Module", "Chapter", "Description"];
        const worksheetData = [
            headers,
            ...data.map(item => [
                `${item.name || '-'} (${item.location || 'Unknown'} | ${item.user_id || '-'})`,
                formatDate(item.date) || '-',
                `${formatTimeToHoursMinutes(item.duration) || '-'} (${trimSeconds(item.in_time) || '-'} to ${trimSeconds(item.out_time) || '-'})`,
                item.module || '-',
                item.chapter || '-',
                item.desc || '-'
            ])
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();

        worksheet['!cols'] = [
            { wch: 40 }, // Student Name
            { wch: 15 }, // Date
            { wch: 30 }, // Duration
            { wch: 20 }, // Module
            { wch: 20 }, // Chapter
            { wch: 30 }  // Description
        ];

        headers.forEach((_, index) => {
            const cell = XLSX.utils.encode_cell({ r: 0, c: index });
            worksheet[cell].s = {
                font: { bold: true },
                fill: { fgColor: { rgb: "4682B4" } },
                color: { rgb: "FFFFFF" },
                alignment: { horizontal: "center" }
            };
        });

        XLSX.utils.book_append_sheet(workbook, worksheet, "Student Task Report");
        XLSX.writeFile(workbook, `${value === "today" ? "today" : "historical"}-student-task-report.xlsx`);
    };

    const getPaginatedData = () => {
        if (!Array.isArray(learningData)) {
            return [];
        }
        const filteredData = getFilteredData(learningData);
        return getSortedData(filteredData);
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key) {
            direction = sortConfig.direction === 'asc' ? 'desc' : 'asc';
        }
        setSortConfig({ key, direction });
    };

    const getSortedData = (data) => {
        if (!sortConfig.key || !Array.isArray(data)) return data;

        return [...data].sort((a, b) => {
            let aValue = a[sortConfig.key];
            let bValue = b[sortConfig.key];
            if (sortConfig.key === 'date') {
                aValue = new Date(a.date);
                bValue = new Date(b.date);
            } else if (sortConfig.key === 'duration') {
                aValue = parseInt(a.duration);
                bValue = parseInt(b.duration);
            }

            if (aValue < bValue) {
                return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'asc' ? 1 : -1;
            }
            return 0;
        });
    };

    const SortableTableCell = ({ field, label }) => (
        <TableCell
            onClick={() => handleSort(field)}
            style={{ cursor: 'pointer' }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <strong>{label}</strong>
                {sortConfig.key === field && (
                    sortConfig.direction === 'asc' ?
                        <ArrowUpward sx={{ fontSize: 16, marginLeft: 1 }} /> :
                        <ArrowDownward sx={{ fontSize: 16, marginLeft: 1 }} />
                )}
            </Box>
        </TableCell>
    );

    const handleChangePage = async (event, newPage) => {
        try {
            setLoading(true);
            setError(null);

            const response = await makeApiRequest('post', '/api/learning/student', {
                token: localStorage.getItem('authToken'),
                start_date: startDate,
                end_date: endDate,
                location: (control == 2 || control == 3 || control == 4) && userLocation ? userLocation : location,
                name: control == 3 && userName ? userName : studentName,
                page: newPage + 1,
                per_page: Math.max(1, rowsPerPage), // Ensure per_page is positive
            });

            if (response.status === 'success') {
                setLearningData(response.data.data);
                setPage(newPage);
                const pagination = response.data.pagination || {};
                setTotalPages(pagination.last_page || Math.ceil(response.data.data.length / rowsPerPage));
                setTotalRecords(pagination.total || response.data.data.length);
            } else {
                throw new Error('Failed to fetch data');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err.response?.data?.message || 'Error fetching data');
            toast.error(err.response?.data?.errors?.per_page?.[0] || err.response?.data?.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    const handleChangeRowsPerPage = async (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        if (isNaN(newRowsPerPage) || newRowsPerPage < 1) {
            toast.error("Rows per page must be at least 1.");
            return;
        }
        try {
            setLoading(true);
            setError(null);

            const response = await makeApiRequest('post', '/api/learning/student', {
                token: localStorage.getItem('authToken'),
                start_date: startDate,
                end_date: endDate,
                location: (control == 2 || control == 3 || control == 4) && userLocation ? userLocation : location,
                name: control == 3 && userName ? userName : studentName,
                page: 1,
                per_page: newRowsPerPage,
            });

            if (response.status === 'success') {
                setLearningData(response.data.data);
                setRowsPerPage(newRowsPerPage);
                setPage(0);
                const pagination = response.data.pagination || {};
                setTotalPages(pagination.last_page || Math.ceil(response.data.data.length / newRowsPerPage));
                setTotalRecords(pagination.total || response.data.data.length);
            } else {
                throw new Error('Failed to fetch data');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err.response?.data?.message || 'Error fetching data');
            toast.error(err.response?.data?.errors?.per_page?.[0] || err.response?.data?.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            <Box sx={{ minHeight: '100vh', backgroundColor: '#ECEDFF', width: "100%", maxHeight: 'auto' }}>
                <Container maxWidth='xl'>
                    <Grid container spacing={2}>
                        <Grid item xs={12} style={{ height: "80px", display: "flex", alignItems: "center" }}>
                            <Typography
                                variant="h3"
                                sx={{
                                    fontFamily: "Roboto",
                                    fontSize: { xs: '24px', sm: "34px" },
                                    fontStyle: "normal",
                                    fontWeight: "500",
                                    lineHeight: { sm: "160%" },
                                    letterSpacing: "0.15px",
                                    color: "#481E82",
                                }}
                            >
                                View Student's Learning Journey
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Card sx={{ display: "flex", justifyContent: { xs: 'flex-start', sm: "flex-start" }, alignItems: "center", height: "100%" }}>
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="centered tabs example"
                                    centered
                                >
                                    <Tab label="Today" value='today' sx={{ fontWeight: value === 'today' ? 'bold' : 'normal' }} />
                                    <Tab label="Historical" value='historical' sx={{ fontWeight: value === 'historical' ? 'bold' : 'normal' }} />
                                </Tabs>
                            </Card>
                        </Grid>

                        <Grid item xs={12}>
                            {value === 'today' && (
                                <Grid container spacing={2} sx={{ paddingLeft: 0, paddingRight: 0, marginTop: "1px" }}>
                                    {(control == 1 || control == 4 || control == 2) && (
                                        <Grid item xs={12}>
                                            <Card sx={{ px: 2, py: 3 }}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={7}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={4} md={6} lg={4}>
                                                                {control == 1 && (
                                                                    <FormControl fullWidth sx={{ maxWidth: "100%" }} size="small">
                                                                        <InputLabel id="dropdown-label">Select Location</InputLabel>
                                                                        <Select
                                                                            labelId="dropdown-label"
                                                                            id="dropdown"
                                                                            value={location}
                                                                            onChange={handleLocationChange}
                                                                            label="Select Location"
                                                                        >
                                                                            <MenuItem value="All Locations">All Locations</MenuItem>
                                                                            {locations && locations.map((loc) => (
                                                                                <MenuItem key={loc.id} value={loc.primary_location}>
                                                                                    {loc.primary_location}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                )}
                                                                {(control == 2 || control == 4) && (
                                                                    <TextField
                                                                        fullWidth
                                                                        sx={{ maxWidth: "100%" }}
                                                                        size="small"
                                                                        value={location}
                                                                        disabled
                                                                    />
                                                                )}
                                                            </Grid>
                                                            <Grid item xs={12} sm={4} md={6} lg={4}>
                                                                {(control == 1 || control == 4 || control == 2) && (
                                                                    <FormControl fullWidth sx={{ maxWidth: "100%" }} size="small">
                                                                        <InputLabel id="batch-dropdown-label">Select Batch</InputLabel>
                                                                        <Select
                                                                            labelId="batch-dropdown-label"
                                                                            id="batch-dropdown"
                                                                            value={selectedBatch || ""}
                                                                            onChange={handleBatchChange}
                                                                            label="Select Batch"
                                                                        >
                                                                            <MenuItem value="">All Batches</MenuItem>
                                                                            {batchList.map((batch, index) => (
                                                                                <MenuItem key={index} value={batch.batch_id}>
                                                                                    {batch.batch_name}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                )}
                                                            </Grid>
                                                            <Grid item xs={12} sm={4} md={6} lg={4}>
                                                                {(control == 1 || control == 4 || control == 2) && (
                                                                    <FormControl fullWidth sx={{ maxWidth: "100%" }} size="small">
                                                                        <InputLabel id="dropdown-label">Select student</InputLabel>
                                                                        <Select
                                                                            labelId="dropdown-label"
                                                                            id="dropdown"
                                                                            value={studentName}
                                                                            onChange={handleStudentChange}
                                                                            label="Select student"
                                                                        >
                                                                            <MenuItem value="">All Students</MenuItem>
                                                                            {studentList.map((studentMember, index) => (
                                                                                <MenuItem key={index} value={studentMember.userid}>
                                                                                    {studentMember?.name || '--'}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} sm={5} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                        <Button variant="contained" size='medium' onClick={handleSubmit}>
                                                            Submit
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Card>
                                        </Grid>
                                    )}
                                </Grid>
                            )}
                            {value === 'historical' && (
                                <Grid container spacing={2} sx={{ paddingLeft: 0, paddingRight: 0, marginTop: "1px" }}>
                                    <Grid item xs={12}>
                                        <Card sx={{ padding: 2, height: "auto" }}>
                                            <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        label="Start Date"
                                                        type="date"
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        size='small'
                                                        sx={{
                                                            width: "100%",
                                                            "& input": {
                                                                color: startDate ? "#000" : "#a2a2a2",
                                                            },
                                                            "& input::-webkit-datetime-edit-text": {
                                                                color: "#a2a2a2",
                                                            },
                                                            "& input::-webkit-datetime-edit-year-field, \
                                                               & input::-webkit-datetime-edit-month-field, \
                                                               & input::-webkit-datetime-edit-day-field": {
                                                                color: startDate ? "#000" : "#a2a2a2",
                                                            }
                                                        }}
                                                        value={startDate}
                                                        onChange={(event) => setStartDate(event.target.value)}
                                                        onFocus={(e) => e.target.showPicker()}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3} md={3}>
                                                    <TextField
                                                        label="End Date"
                                                        type="date"
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        size='small'
                                                        sx={{
                                                            width: "100%",
                                                            "& input": {
                                                                color: endDate ? "#000" : "#a2a2a2",
                                                            },
                                                            "& input::-webkit-datetime-edit-text": {
                                                                color: "#a2a2a2",
                                                            },
                                                            "& input::-webkit-datetime-edit-year-field, \
                                                               & input::-webkit-datetime-edit-month-field, \
                                                               & input::-webkit-datetime-edit-day-field": {
                                                                color: endDate ? "#000" : "#a2a2a2",
                                                            }
                                                        }}
                                                        value={endDate}
                                                        onChange={(event) => setEndDate(event.target.value)}
                                                        onFocus={(e) => e.target.showPicker()}
                                                    />
                                                </Grid>
                                                {(control == 3) && (
                                                    <Grid item xs={12} sm={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                        <Button variant="contained" onClick={handleSubmit}>
                                                            Submit
                                                        </Button>
                                                    </Grid>
                                                )}
                                                <Grid item xs={12} sm={3}>
                                                    {control == 1 && (
                                                         <FormControl fullWidth sx={{ maxWidth: "100%" }} size="small">
                                                             <InputLabel id="dropdown-label">Select Location</InputLabel>
                                                             <Select
                                                                 labelId="dropdown-label"
                                                                 id="dropdown"
                                                                 value={location}
                                                                 onChange={handleLocationChange}
                                                                 label="Select Location"
                                                             >
                                                                 <MenuItem value="All Locations">All Locations</MenuItem>
                                                                 {locations && locations.map((loc) => (
                                                                     <MenuItem key={loc.id} value={loc.primary_location}>
                                                                         {loc.primary_location}
                                                                     </MenuItem>
                                                                 ))}
                                                             </Select>
                                                         </FormControl>
                                                     )}
                                                     {(control == 2 || control == 4) && (
                                                         <TextField
                                                             fullWidth
                                                             sx={{ maxWidth: "100%" }}
                                                             size="small"
                                                             value={userLocation}
                                                             disabled
                                                         />
                                                     )}
                                                </Grid>
                                                {(control == 1 || control == 4 || control == 2) && (
                                                    <Grid item xs={12} sm={3}>
                                                        <FormControl fullWidth sx={{ maxWidth: "100%" }} size="small">
                                                            <InputLabel id="batch-dropdown-label">Select Batch</InputLabel>
                                                            <Select
                                                                labelId="batch-dropdown-label"
                                                                id="batch-dropdown"
                                                                value={selectedBatch}
                                                                onChange={handleBatchChange}
                                                                label="Select Batch"
                                                            >
                                                                <MenuItem value="">All Batches</MenuItem>
                                                                {batchList.map((batch, index) => (
                                                                    <MenuItem key={index} value={batch.batch_id}>
                                                                        {batch.batch_name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                )}
                                                <Grid item xs={12} sm={3}>
                                                    {(control == 1 || control == 4 || control == 2) && (
                                                        <FormControl fullWidth sx={{ maxWidth: "100%" }} size="small">
                                                            <InputLabel id="dropdown-label">Select student</InputLabel>
                                                            <Select
                                                                labelId="dropdown-label"
                                                                id="dropdown"
                                                                value={studentName}
                                                                onChange={handleStudentChange}
                                                                label="Select student"
                                                            >
                                                                <MenuItem value="">All Students</MenuItem>
                                                                {studentList.map((studentMember, index) => (
                                                                    <MenuItem key={index} value={studentMember.userid}>
                                                                        {studentMember.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    )}
                                                </Grid>
                                                {(control == 1 || control == 4 || control == 2) && (
                                                    <Grid item xs={12} sm={9}>
                                                        <Box sx={{ display: "flex", justifyContent: { xs: 'center', sm: "flex-end" } }}>
                                                            <Button variant="contained" size="medium" onClick={handleSubmit}>
                                                                Submit
                                                            </Button>
                                                        </Box>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Card>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ mt: 1 }}>
                                <Box sx={{ maxWidth: '100%', width: '100%', backgroundColor: 'white', borderRadius: 1, boxShadow: 3 }}>
                                    {(control == 1 || control == 4 || control == 2) && (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                flexDirection: { xs: 'column', sm: "row" },
                                                padding: '20px 15px',
                                            }}
                                        >
                                            <Grid container spacing={2} sx={{ justifyContent: "space-between" }}>
                                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                                    <TextField
                                                        value={searchText}
                                                        placeholder="Search"
                                                        onChange={(e) => setSearchText(e.target.value)}
                                                        size='small'
                                                        sx={{ width: "100%" }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <Search />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>
                                                {(control == 1 || control == 4 || control == 2) && (
                                                    <Grid item xs={12} sm={7} md={6}>
                                                        <Grid container spacing={0} sx={{ justifyContent: "flex-end" }}>
                                                            <Button
                                                                variant="contained"
                                                                onClick={handleExport}
                                                                startIcon={<PictureAsPdfIcon />}
                                                                disabled={!learningData.length}
                                                                sx={{
                                                                    backgroundColor: "orange",
                                                                    width: { xs: "100%", sm: "fit-content" },
                                                                    marginRight: { xs: 0, sm: 2 }
                                                                }}
                                                            >
                                                                Download as PDF
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                onClick={handleExportExcel}
                                                                startIcon={<GridOnIcon />}
                                                                disabled={!learningData.length}
                                                                sx={{
                                                                    backgroundColor: "#4CAF50",
                                                                    "&:hover": { backgroundColor: "#45A049" },
                                                                    width: { xs: "100%", sm: "fit-content" },
                                                                    marginTop: { xs: 1, sm: 0 }
                                                                }}
                                                            >
                                                                Export to EXCEL
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Box>
                                    )}

                                    <TableContainer sx={{ width: '100%', overflowX: "auto", marginTop: 0 }}>
                                        <Table>
                                            <TableHead sx={{ backgroundColor: '#f1f4f9' }}>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Student Name</strong></TableCell>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Date</strong></TableCell>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Duration</strong></TableCell>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Module</strong></TableCell>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Chapter</strong></TableCell>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Description</strong></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {hasSubmitted ? (
                                                    getPaginatedData().length > 0 ? (
                                                        getPaginatedData().map((row) => (
                                                            <TableRow key={row.id}>
                                                                <TableCell>
                                                                    {row.studentName || row.name}
                                                                    <br />
                                                                    <Typography variant="body2" sx={{ fontSize: '13px', color: 'gray' }}>
                                                                        {row.location} | {row.studentId || row.user_id}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>{formatDate(row.date)}</TableCell>
                                                                <TableCell>
                                                                    {formatTimeToHoursMinutes(row.duration)}
                                                                    <br />
                                                                    <Typography variant="body2" sx={{ fontSize: '13px', color: 'gray' }}>
                                                                        {trimSeconds(row.in_time)} to {trimSeconds(row.out_time)}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>{row.module}</TableCell>
                                                                <TableCell>{row.chapter}</TableCell>
                                                                <TableCell>{row.desc}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={6} align="center">
                                                                No data available
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={6} align="center">
                                                            Click Submit to see task data
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        component="div"
                                        count={totalRecords}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                    />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    );
};

export default ViewStudentTask;